import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import TicketListPage from './pages/TicketListPage';
import TicketDetailPage from './pages/TicketDetailPage';
import ChatListPage from './pages/ChatListPage';
import ChatPage from './pages/ChatPage';
import KnowledgeBasePage from './pages/KnowledgeBasePage';
import BottomNav from './components/BottomNav';
import { useAuthStore } from './store/authStore';

function App() {
  const { user, initializeAuth } = useAuthStore();

  useEffect(() => {
    // Initialize auth from localStorage/token
    initializeAuth();
  }, [initializeAuth]);

  return (
    <>
      <Toaster position="top-right" />
      <BrowserRouter>
        {user && <BottomNav />}
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/kb" element={<KnowledgeBasePage />} />
          
          {/* Protected Routes */}
          {user ? (
            <>
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/tickets" element={<TicketListPage />} />
              <Route path="/tickets/:id" element={<TicketDetailPage />} />
              <Route path="/chat" element={<ChatListPage />} />
              <Route path="/chat/:id" element={<ChatPage />} />
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
            </>
          ) : (
            <Route path="*" element={<Navigate to="/login" replace />} />
          )}
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
